import { render, staticRenderFns } from "./project.vue?vue&type=template&id=29e8f6e9"
import script from "./project.vue?vue&type=script&lang=tsx"
export * from "./project.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports